export * from '@fhs/routing/src/routes/challenge/[challengeId]';
export { default } from '@fhs/routing/src/routes/challenge/[challengeId]';
